import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth.tsx";
import { LoginPage } from "./pages/Login.tsx";
import { TenantPickerPage } from "./pages/TenantPicker.tsx";
import { TenantLayout } from "./pages/TenantLayout.tsx";
import { StrategicPage } from "./pages/Strategic.tsx";
import { TacticalPage } from "./pages/Tactical.tsx";
import { OperationalPage } from "./pages/Operational.tsx";
import { AlertsPage } from "./pages/Alerts.tsx";
import { IntegrationsSettingsPage } from "./pages/IntegrationsSettings.tsx";
import { TasksPage } from "./pages/Tasks.tsx";
import { AcceptInvitePage } from "./pages/AcceptInvite.tsx";
import { AdminUsersPage } from "./pages/admin/Users.tsx";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { loading, me } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="center-loading">carregando…</div>;
  if (!me) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return <>{children}</>;
}

function Home() {
  const { loading, me } = useAuth();
  if (loading) return <div className="center-loading">carregando…</div>;
  if (!me) return <Navigate to="/login" replace />;
  if (me.memberships.length === 1) return <Navigate to={`/t/${me.memberships[0]!.slug}/strategic`} replace />;
  return <Navigate to="/tenants" replace />;
}

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/invite/:token" element={<AcceptInvitePage />} />
        <Route path="/admin/users" element={<RequireAuth><AdminUsersPage /></RequireAuth>} />
        <Route path="/tenants" element={<RequireAuth><TenantPickerPage /></RequireAuth>} />
        <Route path="/" element={<Home />} />
        <Route path="/t/:slug" element={<RequireAuth><TenantLayout /></RequireAuth>}>
          <Route index element={<Navigate to="strategic" replace />} />
          <Route path="strategic"   element={<StrategicPage />} />
          <Route path="tactical"    element={<TacticalPage />} />
          <Route path="operational" element={<OperationalPage />} />
          <Route path="alerts"      element={<AlertsPage />} />
          <Route path="settings/integrations" element={<IntegrationsSettingsPage />} />
          <Route path="settings/tasks"        element={<TasksPage />} />
        </Route>
        <Route path="*" element={<div className="center-loading">404</div>} />
      </Routes>
    </AuthProvider>
  );
}
